<template>
  <div>
    <div class="itemtitle">{{ $t('lang.applyDetail.chargeDetail') }}</div>
    <div class="filelist">
      <el-row class="rowheader">
        <el-col :span="8" style="text-align: left; padding-left: 15px">{{
            $t('lang.applyDetail.chargeItem')
          }}
        </el-col>
        <el-col :span="8" style="text-align: center">{{ $t('lang.applyDetail.chargeItemCount') }}</el-col>
        <el-col :span="8" style="text-align: center">{{ $t('lang.applyDetail.chargeAmount') }}</el-col>
      </el-row>
      <el-row class="filerow" v-for="(item, index) in applyVo.billDetailVoList" :key="'bill_detail_' + index">
        <el-col :span="8" style="text-align: left; padding-left: 15px">
          {{ isZh ? item.chargeItemChinese : item.chargeItemEnglish }}
        </el-col>
        <el-col :span="8" style="text-align: center">
          {{ item.chargeItemCount }}
        </el-col>
        <el-col :span="8" style="text-align: center">
          {{ (item.chargeCurrency === 'RMB' ? '￥' : '$') + (item.chargeAmount.toFixed(2)) }}
        </el-col>
      </el-row>
    </div>
    <div>
      <el-row class="totalinfo" :butter="30" v-if="applyVo.payType === 'CASH' || applyVo.payType === 'ONLINE'">
        <el-col :span="6">
          {{ $t('lang.applyDetail.sumAmount') }}：<span>{{ applyVo.chargeAmount | moneyFormat }}</span>
        </el-col>
        <el-col :span="6">
          {{
            $t('lang.applyDetail.chargeCurrency')
          }}：<span>{{ applyVo.chargeCurrency === 'RMB' ? $t('lang.common.cny') : $t('lang.common.usd') }}</span>
        </el-col>
        <el-col :span="6">
          {{ $t('lang.applyDetail.payType') }}：<span>{{ payTypeFormatter(applyVo.payType) }}</span>
        </el-col>
        <el-col :span="6">
          {{ $t('lang.applyDetail.payTime') }}：<span>{{ payTime() }}</span>
        </el-col>
      </el-row>
      <el-row class="totalinfoext" :butter="30" v-else-if="applyVo.payType === 'BANK_TRANSFER'">
        <el-col :span="4">
          {{ $t('lang.applyDetail.sumAmount') }}
          <div class="extred">{{ applyVo.chargeAmount | moneyFormat }}</div>
        </el-col>
        <el-col :span="4">
          {{ $t('lang.applyDetail.chargeCurrency') }}
          <div class="extred">{{
              applyVo.chargeCurrency === 'RMB' ? $t('lang.common.cny') : $t('lang.common.usd')
            }}
          </div>
        </el-col>
        <el-col :span="4">
          {{ $t('lang.applyDetail.payType') }}
          <div class="extred">{{ payTypeFormatter(applyVo.payType) }}</div>
        </el-col>
        <el-col :span="4">
          {{ $t('lang.applyDetail.payTime') }}
          <div class="extred">{{ payTime() }}</div>
        </el-col>
        <el-col :span="8">
          <div class="flex" v-if="voucher.url && voucher.previewList.length > 0">
            <div>{{ $t('lang.applyDetail.bankTransferVoucher') }}</div>
            <template>
              <el-card style="width: 200px; height: 120px;">
                <el-image
                  :src="voucher.url"
                  :preview-src-list="voucher.previewList">
                </el-image>
              </el-card>
            </template>
          </div>
          <template v-else>
            {{ $t('lang.applyDetail.bankTransferVoucher') }}
            <div class="extred">{{ $t('lang.applyDetail.noBankTransferVoucher') }}</div>
          </template>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import languageType from '@/locales/languageType'
import { formatDate } from '@/util/util.date'
import { listBankTransferVoucher } from '@/api/apply'
import { getFile } from '@/api/base'

export default {
  name: 'payInfo',
  props: {
    applyVo: {
      type: Object
    }
  },
  data () {
    return {
      voucher: {
        url: '',
        previewList: []
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentLanguage'
    ]),
    isZh: function () {
      return this.currentLanguage === languageType.zh.code
    }
  },
  watch: {
    applyVo: function (nVal) {
      this.loadVoucher()
    }
  },
  methods: {
    payTypeFormatter (val) {
      if (val === 'CASH') {
        return this.$t('lang.applyList.payType.cash')
      } else if (val === 'ONLINE') {
        return this.$t('lang.applyList.payType.online')
      } else if (val === 'BANK_TRANSFER') {
        return this.$t('lang.applyList.payType.bankTransfer')
      }
    },
    payTime () {
      if (this.applyVo.payStatus === 'PAID') {
        return formatDate(this.applyVo.payTime)
      } else if (this.applyVo.payStatus === 'NO_NEED_CONFIRM') {
        return this.$t('lang.applyList.payStatus.noNeedConfirm')
      } else if (this.applyVo.payStatus === 'TO_BE_CONFIRMED') {
        return this.$t('lang.applyList.payStatus.toBeConfirmed')
      } else if (this.applyVo.payStatus === 'FAILED') {
        return this.$t('lang.applyList.payStatus.failed')
      }
    },
    loadVoucher () {
      listBankTransferVoucher({
        id: this.applyVo.id
      }).then(res => {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            getFile(res.data[i]).then(file => {
              if (file) {
                // objectUrls.push()
                const objectUrl = window.URL.createObjectURL(new Blob([file]))
                if (i === 0) {
                  this.voucher.url = objectUrl
                }
                this.voucher.previewList.push(objectUrl)
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.itemtitle {
  background: #a2100e;
  color: #fff;
  text-align: center;
  height: 35px;
  line-height: 35px;
  box-shadow: -1px 3px 11px 2px rgb(136 136 136 / 51%);
}

.filelist .rowheader {
  font-size: 12px;
  color: #a2100e;
  padding: 10px 0 5px 0;
}

.filelist .filerow {
  margin: 5px 0;
  font-size: 12px;
  line-height: 35px;
  color: #707070;
}

.filelist .filerow:nth-child(even) {
  background: #ededed;
}

/deep/ .el-button--text {
  color: #606266;
}

/deep/ .el-button--text i {
  color: #a2100e;
  margin-left: 5px;
  font-size: 18px;
}

/deep/ .el-button--text span {
  display: flex;
  align-items: center;
}

.totalinfo {
  margin-top: 20px;
  background: #d2d2d2;
  padding: 15px;
  font-weight: bold;
  font-size: 18px;
  color: #5b5b5b;
  text-align: left;
}

.totalinfo span {
  color: #a2100e;
}

.totalinfoext {
  margin-top: 20px;
  background: #d2d2d2;
  padding: 15px;
  font-weight: bold;
  font-size: 18px;
  color: #5b5b5b;
  text-align: left;
}

.totalinfoext .extred {
  color: #a2100e;
  display: block;
  line-height: 50px;
}

.flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
</style>
